class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

// Cart drawer promotional item helpers
window.addProductToCartByHandle = function(handle, fallbackVariantId, buttonEl) {
  if (buttonEl) {
    buttonEl.setAttribute('data-original-text', buttonEl.textContent);
    buttonEl.textContent = 'Adding...';
    buttonEl.style.opacity = '0.6';
    buttonEl.style.pointerEvents = 'none';
  }

  const restoreButton = () => {
    if (buttonEl) {
      buttonEl.style.opacity = '1';
      buttonEl.style.pointerEvents = '';
      const origText = buttonEl.getAttribute('data-original-text');
      if (origText) buttonEl.textContent = origText;
    }
  };

  const addVariantToCart = (variantId) => {
    if (!variantId) {
      restoreButton();
      window.location.href = '/products/' + handle;
      return;
    }
    const cartDrawer = document.querySelector('cart-drawer');
    const url = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add.js';
    const sectionsToRender = cartDrawer && typeof cartDrawer.getSectionsToRender === 'function'
      ? cartDrawer.getSectionsToRender().map((s) => s.id)
      : ['cart-drawer', 'cart-icon-bubble'];

    const body = JSON.stringify({
      id: variantId,
      quantity: 1,
      sections: sectionsToRender,
      sections_url: window.location.pathname
    });

    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: body
    })
    .then((response) => response.json())
    .then((parsedState) => {
      restoreButton();
      if (parsedState.status) {
        console.warn('Cart add warning:', parsedState.description || parsedState.message);
        window.location.href = '/products/' + handle;
        return;
      }
      if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
        cartDrawer.renderContents(parsedState);
      } else {
        window.location.reload();
      }
    })
    .catch((error) => {
      console.error('Error adding product to cart:', error);
      restoreButton();
      window.location.href = '/products/' + handle;
    });
  };

  if (fallbackVariantId && fallbackVariantId !== '' && fallbackVariantId !== 'null' && fallbackVariantId !== 'undefined') {
    addVariantToCart(fallbackVariantId);
  } else {
    fetch('/products/' + handle + '.js')
      .then((res) => res.json())
      .then((product) => {
        if (product && product.variants && product.variants.length > 0) {
          const available = product.variants.find((v) => v.available) || product.variants[0];
          addVariantToCart(available.id);
        } else {
          restoreButton();
          window.location.href = '/products/' + handle;
        }
      })
      .catch((err) => {
        console.error('Error fetching product JSON:', err);
        restoreButton();
        window.location.href = '/products/' + handle;
      });
  }
};

window.addBothTorsoGifts = function(caseVariantId, coverVariantId, buttonEl) {
  if (buttonEl) {
    buttonEl.setAttribute('data-original-text', buttonEl.textContent);
    buttonEl.textContent = 'Adding both...';
    buttonEl.style.opacity = '0.6';
    buttonEl.style.pointerEvents = 'none';
  }

  const restore = () => {
    if (buttonEl) {
      buttonEl.style.opacity = '1';
      buttonEl.style.pointerEvents = '';
      const orig = buttonEl.getAttribute('data-original-text');
      if (orig) buttonEl.textContent = orig;
    }
  };

  const executeAdd = (vCaseId, vCoverId) => {
    const items = [];
    if (vCaseId) items.push({ id: vCaseId, quantity: 1 });
    if (vCoverId) items.push({ id: vCoverId, quantity: 1 });

    if (items.length === 0) {
      restore();
      return;
    }

    const cartDrawer = document.querySelector('cart-drawer');
    const url = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add.js';
    const sectionsToRender = cartDrawer && typeof cartDrawer.getSectionsToRender === 'function'
      ? cartDrawer.getSectionsToRender().map((s) => s.id)
      : ['cart-drawer', 'cart-icon-bubble'];

    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        items: items,
        sections: sectionsToRender,
        sections_url: window.location.pathname
      })
    })
    .then((r) => r.json())
    .then((parsedState) => {
      restore();
      if (parsedState.status) {
        console.warn('Cart add error:', parsedState);
        return;
      }
      if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
        cartDrawer.renderContents(parsedState);
      } else {
        window.location.reload();
      }
    })
    .catch((err) => {
      console.error('Error adding both gifts:', err);
      restore();
    });
  };

  const p1 = (caseVariantId && caseVariantId !== '') 
    ? Promise.resolve(caseVariantId) 
    : fetch('/products/torso-electronics-s4-sampler-carry-case.js').then((r) => r.json()).then((p) => (p.variants.find((v) => v.available) || p.variants[0]).id).catch(() => null);

  const p2 = (coverVariantId && coverVariantId !== '') 
    ? Promise.resolve(coverVariantId) 
    : fetch('/products/s-4-cover.js').then((r) => r.json()).then((p) => (p.variants.find((v) => v.available) || p.variants[0]).id).catch(() => null);

  Promise.all([p1, p2]).then(([id1, id2]) => {
    executeAdd(id1, id2);
  });
};

// Delegated click handler so dynamically re-rendered links work 100% reliably
document.addEventListener('click', function(event) {
  const trigger = event.target.closest('[data-cart-add-handle]');
  if (!trigger) return;
  event.preventDefault();
  const handle = trigger.getAttribute('data-cart-add-handle');
  const variantId = trigger.getAttribute('data-cart-add-variant-id');
  if (typeof window.addProductToCartByHandle === 'function') {
    window.addProductToCartByHandle(handle, variantId, trigger);
  }
});

